<script>
  import moment from 'moment';
  import DatePicker from 'vue2-datepicker';
  import conciliacaoProjetoServico from '../servico';
  import SelecaoBusca from './SelecaoBusca.vue';
  import aplicarMascaraData from '../mascara-data';

  const CAMPOS_COMPARADOS = [
    'idProjeto', 'idConta', 'idRubrica', 'idSubRubrica', 'idRubricaDebito', 'idSubRubricaDebito',
    'complemento', 'documento', 'documentoPadraoTransferencia', 'complementoPadraoTransferencia',
    'palavrasTransferencia', 'palavrasAplicacao', 'idTipoAplicacaoPadrao', 'prazoResgatePadrao',
    'automacaoAplicacaoResgate',
    'idCategoriaFinanceiraDebito', 'idCategoriaFinanceiraCredito', 'idCategoriaFinanceiraAplicacao',
    'idRubricaTarifaProprio', 'idSubRubricaTarifaProprio', 'idContaTarifaProprio',
    'idProjetoTarifaCentral', 'idRubricaTarifaCentral', 'idSubRubricaTarifaCentral', 'idContaTarifaCentral',
    'idCategoriaFinanceiraTarifa',
  ];

  const TESOURARIA_VAZIA = {
    valorMinimo: '', diasAplicacaoParada: '', diasCompromissoAtrasado: '', diasTransferenciaAtrasada: '',
    diasUteisReferencia: '1', horizonteCompromissos: '1',
  };

  export default {
    components: { SelecaoBusca, DatePicker },
    props: {
      secaoInicial: { type: String, default: 'corte' },
    },
    data() {
      return {
        carregando: true,
        salvando: false,
        validar: false,
        secao: 'corte',
        tesouraria: Object.assign({}, TESOURARIA_VAZIA),
        tesourariaOriginal: '',
        carregandoTesouraria: true,
        dataCorte: null,
        dataCorteOriginal: null,
        mesmaRubrica: true,
        mesmaRubricaOriginal: true,
        original: {},
        bancoIA: '',
        conteudoIA: '',
        conteudoIAOriginal: '',
        bancosIA: [],
        globalIA: { sinonimos: 0, orientacoes: 0 },
        carregandoIA: false,
        impacto: null,
        carregandoImpacto: false,
        timerImpacto: null,
        novoTermo: { transferencia: '', aplicacao: '' },
        textos: { documentos: [], complementos: [], historicos: [] },
        textosOriginal: '{"documentos":[],"complementos":[],"historicos":[]}',
        seqTexto: 0,
        configuracao: {
          idProjeto: 0,
          idConta: 0,
          idRubrica: 0,
          idSubRubrica: 0,
          idRubricaDebito: 0,
          idSubRubricaDebito: 0,
          complemento: '',
          documento: '',
          dataCorteBanco: '',
          documentoPadraoTransferencia: '',
          complementoPadraoTransferencia: '',
          palavrasTransferencia: '',
          palavrasAplicacao: '',
          idTipoAplicacaoPadrao: 0,
          prazoResgatePadrao: 0,
          automacaoAplicacaoResgate: false,
          idCategoriaFinanceiraDebito: 0,
          idCategoriaFinanceiraCredito: 0,
          idCategoriaFinanceiraAplicacao: 0,
          idRubricaTarifaProprio: 0,
          idSubRubricaTarifaProprio: 0,
          idContaTarifaProprio: 0,
          idProjetoTarifaCentral: 0,
          idRubricaTarifaCentral: 0,
          idSubRubricaTarifaCentral: 0,
          idContaTarifaCentral: 0,
          idCategoriaFinanceiraTarifa: 0,
          nomeProjeto: '',
          nomeConta: '',
          nomeRubrica: '',
          nomeSubrubrica: '',
          nomeRubricaDebito: '',
          nomeSubrubricaDebito: '',
          nomeTipoAplicacaoPadrao: '',
          nomeCategoriaFinanceiraDebito: '',
          nomeCategoriaFinanceiraCredito: '',
          nomeCategoriaFinanceiraAplicacao: '',
          nomeRubricaTarifaProprio: '',
          nomeSubrubricaTarifaProprio: '',
          nomeContaTarifaProprio: '',
          nomeProjetoTarifaCentral: '',
          nomeRubricaTarifaCentral: '',
          nomeSubrubricaTarifaCentral: '',
          nomeContaTarifaCentral: '',
          nomeCategoriaFinanceiraTarifa: '',
        },
      }
    },
    computed: {
      secoes() {
        return [
          { chave: 'corte', titulo: 'Data de corte', resumo: this.resumoCorte, ok: true },
          { chave: 'creditos', titulo: 'Créditos a identificar', resumo: this.resumoCreditos, ok: this.completo },
          { chave: 'operacoes', titulo: 'Transferências e aplicações', resumo: this.resumoOperacoes, ok: true },
          { chave: 'textos', titulo: 'Textos padrão', resumo: this.resumoTextos, ok: true },
          { chave: 'tarifas', titulo: 'Tarifas TED/DOC', resumo: this.resumoTarifas, ok: this.tarifasCompletas },
          { chave: 'ia', titulo: 'Regras da IA', resumo: this.resumoIA, ok: true },
          { chave: 'tesouraria', titulo: 'Posição de Tesouraria', resumo: this.resumoTesouraria, ok: true },
        ];
      },
      resumoTesouraria() {
        if (this.carregandoTesouraria) return 'Carregando...';
        const t = this.tesouraria;
        const referencia = +t.diasUteisReferencia === 0 ? 'Hoje' : 'D-' + t.diasUteisReferencia;
        const horizonte = +t.horizonteCompromissos === -1 ? 'só o dia' : 'até D+' + t.horizonteCompromissos;
        const minimo = this.lerValor(t.valorMinimo);
        return 'Referência ' + referencia + ' · ' + horizonte
          + (minimo > 0 ? ' · mín. R$ ' + minimo.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '');
      },
      tesourariaAlterada() {
        return !this.carregandoTesouraria && JSON.stringify(this.payloadTesouraria()) !== this.tesourariaOriginal;
      },
      corteFormatado() { return this.dataCorte ? moment(this.dataCorte).format('DD/MM/YYYY') : ''; },
      resumoCorte() {
        if (!this.dataCorte) return 'Sem corte — todo o histórico';
        return this.dataValida ? 'A partir de ' + this.corteFormatado : 'Data inválida';
      },
      resumoCreditos() {
        if (!this.completo) return 'Falta preencher — regularização indisponível';
        const conta = this.configuracao.nomeConta || 'conta transitória';
        return conta + (this.configuracao.idProjeto ? ' · projeto ' + this.configuracao.idProjeto : '');
      },
      resumoOperacoes() {
        const partes = [];
        if (this.configuracao.documentoPadraoTransferencia) partes.push('Documento ' + this.configuracao.documentoPadraoTransferencia);
        if (this.configuracao.nomeCategoriaFinanceiraCredito) partes.push(this.configuracao.nomeCategoriaFinanceiraCredito);
        return partes.length > 0 ? partes.join(' · ') : 'Sem sugestões definidas';
      },
      resumoTextos() {
        const envio = this.textosParaEnvio();
        const d = envio.documentos.length;
        const c = envio.complementos.length;
        const h = envio.historicos.length;

        if (d + c + h === 0) return 'Nenhum texto cadastrado';

        return d + (d === 1 ? ' documento' : ' documentos') + ' · ' + c + (c === 1 ? ' complemento' : ' complementos')
          + ' · ' + h + (h === 1 ? ' histórico' : ' históricos');
      },
      textosAlterados() {
        return JSON.stringify(this.textosParaEnvio()) !== this.textosOriginal;
      },
      resumoTarifas() {
        if (this.tarifasCompletas) return 'Próprio projeto e centralizador definidos';
        if (!this.tarifaProprioCompleta && !this.tarifaCentralCompleta) return 'Falta preencher os dois casos';
        return this.tarifaProprioCompleta ? 'Falta o caso que não permite' : 'Falta o caso que permite';
      },
      tarifaProprioCompleta() {
        const c = this.configuracao;
        return c.idRubricaTarifaProprio > 0 && c.idSubRubricaTarifaProprio > 0 && c.idContaTarifaProprio > 0;
      },
      tarifaCentralCompleta() {
        const c = this.configuracao;
        return c.idProjetoTarifaCentral > 0 && c.idRubricaTarifaCentral > 0
            && c.idSubRubricaTarifaCentral > 0 && c.idContaTarifaCentral > 0;
      },
      tarifaProprioIniciada() {
        const c = this.configuracao;
        return c.idRubricaTarifaProprio > 0 || c.idSubRubricaTarifaProprio > 0 || c.idContaTarifaProprio > 0;
      },
      tarifaCentralIniciada() {
        const c = this.configuracao;
        return c.idProjetoTarifaCentral > 0 || c.idRubricaTarifaCentral > 0
            || c.idSubRubricaTarifaCentral > 0 || c.idContaTarifaCentral > 0;
      },
      tarifasCompletas() { return this.tarifaProprioCompleta && this.tarifaCentralCompleta; },
      resumoIA() {
        const s = this.sinonimosIA, o = this.orientacoesIA;
        if (s + o === 0) return 'Nenhuma regra escrita';
        return s + (s === 1 ? ' abreviação' : ' abreviações') + ' · ' + o + (o === 1 ? ' orientação' : ' orientações');
      },
      dataValida() {
        if (!this.dataCorte) return true;
        const data = moment(this.dataCorte);
        return data.isValid() && data.year() >= 1990 && data.year() <= 2100;
      },
      camposFaltando() {
        if (!this.validar) return {};
        const c = this.configuracao;
        const f = {};
        if (!this.dataValida) f.dataCorte = 'Data inválida — use dd/mm/aaaa';
        ['idProjeto', 'idConta', 'idRubrica', 'idSubRubrica'].forEach(k => { if (!(c[k] > 0)) f[k] = 'Campo obrigatório'; });
        if (!this.mesmaRubrica)
          ['idRubricaDebito', 'idSubRubricaDebito'].forEach(k => { if (!(c[k] > 0)) f[k] = 'Campo obrigatório'; });
        if (this.tarifaProprioIniciada)
          ['idRubricaTarifaProprio', 'idSubRubricaTarifaProprio', 'idContaTarifaProprio']
            .forEach(k => { if (!(c[k] > 0)) f[k] = 'Complete a tarifa lançada no próprio projeto'; });
        if (this.tarifaCentralIniciada)
          ['idProjetoTarifaCentral', 'idContaTarifaCentral', 'idRubricaTarifaCentral', 'idSubRubricaTarifaCentral']
            .forEach(k => { if (!(c[k] > 0)) f[k] = 'Complete a tarifa do projeto centralizador'; });
        return f;
      },
      secoesComFalta() {
        const f = this.camposFaltando;
        const r = {};
        if (f.dataCorte) r.corte = true;
        if (['idProjeto', 'idConta', 'idRubrica', 'idSubRubrica', 'idRubricaDebito', 'idSubRubricaDebito'].some(k => f[k])) r.creditos = true;
        if (Object.keys(f).some(k => /Tarifa/.test(k))) r.tarifas = true;
        return r;
      },
      completo() {
        const c = this.configuracao;
        return c.idProjeto > 0 && c.idConta > 0
            && c.idRubrica > 0 && c.idSubRubrica > 0
            && (this.mesmaRubrica || (c.idRubricaDebito > 0 && c.idSubRubricaDebito > 0));
      },
      naturezaCredito() { return this.mesmaRubrica ? 'A' : 'C'; },
      termosTransferencia() { return this.separarTermos(this.configuracao.palavrasTransferencia); },
      termosAplicacao() { return this.separarTermos(this.configuracao.palavrasAplicacao); },
      linhasIA() { return (this.conteudoIA || '').replace(/\r\n/g, '\n').split('\n'); },
      sinonimosIA() { return this.linhasIA.filter(l => this.ehSinonimo(l)).length; },
      orientacoesIA() { return this.linhasIA.filter(l => l.trim() !== '' && !this.ehSinonimo(l)).length; },
      escopoIA() {
        if (!this.bancoIA) return 'Vale para todos os bancos.';
        const banco = this.bancosIA.filter(b => b.numeroBanco === this.bancoIA)[0];
        return 'Vale só para ' + this.bancoIA + (banco && banco.nomeBanco ? ' · ' + banco.nomeBanco : '')
             + '. As regras gerais continuam valendo junto.';
      },
      alteracoes() {
        if (this.carregando) return 0;

        let total = CAMPOS_COMPARADOS.filter(c => (this.configuracao[c] || '') !== (this.original[c] || '')).length;

        const corteAtual = this.dataCorte ? moment(this.dataCorte).format('YYYY-MM-DD') : '';
        if (corteAtual !== (this.dataCorteOriginal || '')) total++;
        if (this.mesmaRubrica !== this.mesmaRubricaOriginal) total++;
        if (this.conteudoIA !== this.conteudoIAOriginal) total++;
        if (this.textosAlterados) total++;
        if (this.tesourariaAlterada) total++;

        return total;
      },
      temAlteracao() { return this.alteracoes > 0; },
    },
    mounted() {
      this.carregar();
      this.carregarTextos();
      this.carregarTesouraria();
      if (this.secaoInicial !== 'corte') this.irPara(this.secaoInicial);
      this.$nextTick(() => aplicarMascaraData('dataCorteBanco'));
    },
    methods: {
      carregar() {
        this.carregando = true;
        conciliacaoProjetoServico.configuracaoCredito()
          .then(dados => {
            this.configuracao = Object.assign(this.configuracao, dados || {});
            this.dataCorte = this.configuracao.dataCorteBanco ? moment(this.configuracao.dataCorteBanco, 'YYYY-MM-DD').toDate() : null;
            this.dataCorteOriginal = this.configuracao.dataCorteBanco || '';
            this.mesmaRubrica = !(this.configuracao.idRubricaDebito > 0
                                  && (this.configuracao.idRubricaDebito !== this.configuracao.idRubrica
                                      || this.configuracao.idSubRubricaDebito !== this.configuracao.idSubRubrica));
            this.mesmaRubricaOriginal = this.mesmaRubrica;
            this.original = Object.assign({}, this.configuracao);
            this.carregando = false;
          })
          .catch(() => { this.carregando = false; toastr.error('Não foi possível carregar as configurações.'); });
      },
      carregarTextos() {
        conciliacaoProjetoServico.textosPadrao()
          .then(dados => {
            this.textos = {
              documentos: this.montarTextos(dados && dados.documentos),
              complementos: this.montarTextos(dados && dados.complementos),
              historicos: this.montarTextos(dados && dados.historicos),
            };
            this.textosOriginal = JSON.stringify(this.textosParaEnvio());
          })
          .catch(() => { this.textosOriginal = JSON.stringify(this.textosParaEnvio()); });
      },
      carregarTesouraria() {
        this.carregandoTesouraria = true;
        conciliacaoProjetoServico.configuracaoTesouraria()
          .then(dados => {
            const d = dados || {};
            const inteiro = (v, padrao) => '' + (v === undefined || v === null ? padrao : v);
            this.tesouraria = {
              valorMinimo: (d.valorMinimo || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
              diasAplicacaoParada: '' + (d.diasAplicacaoParada || ''),
              diasCompromissoAtrasado: inteiro(d.diasCompromissoAtrasado, ''),
              diasTransferenciaAtrasada: inteiro(d.diasTransferenciaAtrasada, ''),
              diasUteisReferencia: inteiro(d.diasUteisReferencia, 1),
              horizonteCompromissos: '' + (d.horizonteCompromissos || 1),
            };
            this.tesourariaOriginal = JSON.stringify(this.payloadTesouraria());
            this.carregandoTesouraria = false;
          })
          .catch(() => {
            this.tesourariaOriginal = JSON.stringify(this.payloadTesouraria());
            this.carregandoTesouraria = false;
            toastr.error('Não foi possível carregar as configurações da Posição de Tesouraria.');
          });
      },
      lerValor(texto) {
        const limpo = ('' + (texto || '')).replace(/[^0-9,.-]/g, '').replace(/\./g, '').replace(',', '.');
        const n = +limpo;
        return isNaN(n) ? 0 : n;
      },
      payloadTesouraria() {
        const t = this.tesouraria;
        return {
          valorMinimo: this.lerValor(t.valorMinimo),
          diasAplicacaoParada: parseInt(t.diasAplicacaoParada, 10) || 0,
          diasCompromissoAtrasado: parseInt(t.diasCompromissoAtrasado, 10) || 0,
          diasTransferenciaAtrasada: parseInt(t.diasTransferenciaAtrasada, 10) || 0,
          diasUteisReferencia: parseInt(t.diasUteisReferencia, 10) || 0,
          horizonteCompromissos: parseInt(t.horizonteCompromissos, 10) || 1,
        };
      },
      montarTextos(lista) {
        return (lista || []).map(t => ({ id: ++this.seqTexto, texto: t }));
      },
      textosParaEnvio() {
        return {
          documentos: this.textos.documentos.map(t => (t.texto || '').replace(/^\s+/, '')).filter(t => t.trim() !== ''),
          complementos: this.textos.complementos.map(t => (t.texto || '').replace(/^\s+/, '')).filter(t => t.trim() !== ''),
          historicos: this.textos.historicos.map(t => (t.texto || '').replace(/^\s+/, '')).filter(t => t.trim() !== ''),
        };
      },
      adicionarTexto(tipo) {
        this.textos[tipo].push({ id: ++this.seqTexto, texto: '' });
        this.$nextTick(() => {
          const campos = this.$refs['texto-' + tipo];
          if (campos && campos.length > 0) campos[campos.length - 1].focus();
        });
      },
      removerTexto(tipo, indice) {
        this.textos[tipo].splice(indice, 1);
      },
      moverTexto(tipo, indice, passo) {
        const lista = this.textos[tipo];
        const destino = indice + passo;

        if (destino < 0 || destino >= lista.length) return;

        lista.splice(destino, 0, lista.splice(indice, 1)[0]);
      },
      irPara(chave) {
        if (chave === 'ia' && this.bancosIA.length === 0) this.abrirIA();
        else this.secao = chave;
      },
      agendarImpacto() {
        if (this.carregando) return;
        clearTimeout(this.timerImpacto);
        this.timerImpacto = setTimeout(() => this.carregarImpacto(), 500);
      },
      carregarImpacto() {
        if (!this.dataValida) return;
        this.carregandoImpacto = true;
        const texto = this.dataCorte ? moment(this.dataCorte).format('YYYY-MM-DD') : '';
        conciliacaoProjetoServico.impactoCorte(texto)
          .then(dados => { this.impacto = dados || null; this.carregandoImpacto = false; })
          .catch(() => { this.impacto = null; this.carregandoImpacto = false; });
      },
      numero(v) { return (+v || 0).toLocaleString('pt-BR'); },
      separarTermos(texto) {
        return (texto || '').split(';').map(t => t.trim()).filter(t => t !== '');
      },
      juntarTermos(lista) { return lista.join(';'); },
      adicionarTermo(campo) {
        const chave = campo === 'transferencia' ? 'palavrasTransferencia' : 'palavrasAplicacao';
        const termo = (this.novoTermo[campo] || '').trim();
        if (!termo) return;

        const lista = this.separarTermos(this.configuracao[chave]);
        if (lista.some(t => t.toLowerCase() === termo.toLowerCase())) {
          this.novoTermo[campo] = '';
          return;
        }

        lista.push(termo);
        this.configuracao[chave] = this.juntarTermos(lista);
        this.novoTermo[campo] = '';
      },
      removerTermo(campo, termo) {
        const chave = campo === 'transferencia' ? 'palavrasTransferencia' : 'palavrasAplicacao';
        this.configuracao[chave] = this.juntarTermos(this.separarTermos(this.configuracao[chave]).filter(t => t !== termo));
      },
      buscarProjetos(termo) { return conciliacaoProjetoServico.projetosCredito(termo); },
      buscarContas(termo) { return conciliacaoProjetoServico.contasCredito(this.configuracao.idProjeto || 0, termo); },
      buscarRubricas(termo) { return conciliacaoProjetoServico.rubricasCredito(this.configuracao.idProjeto || 0, termo, this.naturezaCredito); },
      buscarSubrubricas(termo) { return conciliacaoProjetoServico.subrubricasCredito(this.configuracao.idProjeto || 0, this.configuracao.idRubrica || 0, termo, this.naturezaCredito); },
      buscarRubricasDebito(termo) { return conciliacaoProjetoServico.rubricasCredito(this.configuracao.idProjeto || 0, termo, 'D'); },
      buscarSubrubricasDebito(termo) { return conciliacaoProjetoServico.subrubricasCredito(this.configuracao.idProjeto || 0, this.configuracao.idRubricaDebito || 0, termo, 'D'); },
      buscarCategoriasFinanceiras(termo) { return conciliacaoProjetoServico.categoriasFinanceiras(termo); },
      buscarRubricasTarifaProprio(termo) { return conciliacaoProjetoServico.rubricasGerais(termo, 'D'); },
      buscarSubrubricasTarifaProprio(termo) { return conciliacaoProjetoServico.subrubricasGerais(this.configuracao.idRubricaTarifaProprio || 0, termo, 'D'); },
      buscarContasTarifaProprio(termo) { return conciliacaoProjetoServico.contasGerais(termo); },
      buscarProjetosTarifaCentral(termo) { return conciliacaoProjetoServico.projetosCredito(termo); },
      buscarRubricasTarifaCentral(termo) { return conciliacaoProjetoServico.rubricasCredito(this.configuracao.idProjetoTarifaCentral || 0, termo, 'D'); },
      buscarSubrubricasTarifaCentral(termo) { return conciliacaoProjetoServico.subrubricasCredito(this.configuracao.idProjetoTarifaCentral || 0, this.configuracao.idRubricaTarifaCentral || 0, termo, 'D'); },
      buscarContasTarifaCentral(termo) { return conciliacaoProjetoServico.contasCredito(this.configuracao.idProjetoTarifaCentral || 0, termo); },
      aoEscolherRubricaTarifaProprio(opcao) {
        this.configuracao.nomeRubricaTarifaProprio = opcao ? opcao.nome : '';
        this.configuracao.idSubRubricaTarifaProprio = 0;
        this.configuracao.nomeSubrubricaTarifaProprio = '';
        this.preencherUnico('subrubricaTarifaProprio');
      },
      aoEscolherProjetoTarifaCentral(opcao) {
        this.configuracao.nomeProjetoTarifaCentral = opcao ? opcao.nome : '';
        this.limparTarifaCentral();
        this.preencherUnico('contaTarifaCentral');
      },
      limparTarifaCentral() {
        this.configuracao.idRubricaTarifaCentral = 0;
        this.configuracao.nomeRubricaTarifaCentral = '';
        this.configuracao.idSubRubricaTarifaCentral = 0;
        this.configuracao.nomeSubrubricaTarifaCentral = '';
        this.configuracao.idContaTarifaCentral = 0;
        this.configuracao.nomeContaTarifaCentral = '';
      },
      aoEscolherRubricaTarifaCentral(opcao) {
        this.configuracao.nomeRubricaTarifaCentral = opcao ? opcao.nome : '';
        this.configuracao.idSubRubricaTarifaCentral = 0;
        this.configuracao.nomeSubrubricaTarifaCentral = '';
        this.preencherUnico('subrubricaTarifaCentral');
      },
      aoEscolherProjeto(opcao) {
        this.configuracao.nomeProjeto = opcao ? opcao.nome : '';
        this.limparConta();
        this.limparRubricas();
        this.preencherUnico('conta');
      },
      preencherUnico(...refs) {
        this.$nextTick(() => {
          refs.forEach(nome => {
            const campo = this.$refs[nome];
            if (campo && campo.preencherSeUnico) campo.preencherSeUnico();
          });
        });
      },
      limparConta() {
        this.configuracao.idConta = 0;
        this.configuracao.nomeConta = '';
      },
      limparRubricas() {
        this.configuracao.idRubrica = 0;
        this.configuracao.nomeRubrica = '';
        this.configuracao.idSubRubrica = 0;
        this.configuracao.nomeSubrubrica = '';
        this.configuracao.idRubricaDebito = 0;
        this.configuracao.nomeRubricaDebito = '';
        this.configuracao.idSubRubricaDebito = 0;
        this.configuracao.nomeSubrubricaDebito = '';
      },
      aoEscolherRubrica(opcao) {
        this.configuracao.nomeRubrica = opcao ? opcao.nome : '';
        this.configuracao.idSubRubrica = 0;
        this.configuracao.nomeSubrubrica = '';
        this.preencherUnico('subrubrica');
      },
      aoEscolherRubricaDebito(opcao) {
        this.configuracao.nomeRubricaDebito = opcao ? opcao.nome : '';
        this.configuracao.idSubRubricaDebito = 0;
        this.configuracao.nomeSubrubricaDebito = '';
        this.preencherUnico('subrubricaDebito');
      },
      alternarMesmaRubrica() {
        this.mesmaRubrica = !this.mesmaRubrica;
        if (this.mesmaRubrica) {
          this.configuracao.idRubricaDebito = 0;
          this.configuracao.nomeRubricaDebito = '';
          this.configuracao.idSubRubricaDebito = 0;
          this.configuracao.nomeSubrubricaDebito = '';
          this.limparRubricas();
        }
      },
      ehSinonimo(linha) {
        const texto = (linha || '').trim();
        const pos = texto.indexOf('=');
        if (pos <= 0 || pos === texto.length - 1) return false;

        const esquerda = texto.substring(0, pos).trim();
        const direita = texto.substring(pos + 1).trim();

        if (!esquerda || !direita || esquerda.length > 40) return false;
        if (esquerda.split(/\s+/).length > 4) return false;

        return !/[.,:]$/.test(esquerda);
      },
      abrirIA() {
        this.secao = 'ia';
        if (this.bancosIA.length === 0) this.carregarBancosIA();
        this.carregarGlossario();
      },
      carregarBancosIA() {
        conciliacaoProjetoServico.bancosGlossarioIA()
          .then(dados => {
            this.bancosIA = (dados && dados.bancos) || [];
            this.globalIA = (dados && dados.global) || { sinonimos: 0, orientacoes: 0 };
          })
          .catch(() => {});
      },
      carregarGlossario() {
        this.carregandoIA = true;
        conciliacaoProjetoServico.glossarioIA(this.bancoIA)
          .then(dados => {
            this.conteudoIA = (dados && dados.conteudo) || '';
            this.conteudoIAOriginal = this.conteudoIA;
            this.carregandoIA = false;
          })
          .catch(() => { this.carregandoIA = false; toastr.error('Não foi possível carregar as regras.'); });
      },
      trocarBancoIA(numeroBanco) {
        if (this.conteudoIA !== this.conteudoIAOriginal) {
          toastr.warning('Salve as regras deste banco antes de trocar.');
          return;
        }
        this.bancoIA = numeroBanco;
        this.carregarGlossario();
      },
      salvarGlossario() {
        this.salvando = true;
        conciliacaoProjetoServico.salvarGlossarioIA({ numeroBanco: this.bancoIA, conteudo: this.conteudoIA })
          .then(dados => {
            this.salvando = false;
            this.conteudoIA = (dados && dados.conteudo) || '';
            this.conteudoIAOriginal = this.conteudoIA;
            this.carregarBancosIA();
            toastr.success('Regras salvas · ' + this.sinonimosIA + ' abreviação(ões), ' + this.orientacoesIA + ' orientação(ões).');
          })
          .catch(() => { this.salvando = false; toastr.error('Não foi possível salvar as regras.'); });
      },
      fechar() { this.$emit('fechar'); },
      secaoComFalta(chave) { return !!this.secoesComFalta[chave]; },
      salvar() {
        this.validar = true;
        if (!this.dataValida) {
          this.secao = 'corte';
          toastr.warning('Informe uma data de corte válida, no formato dd/mm/aaaa.');
          return;
        }

        if (!this.completo) {
          this.secao = 'creditos';
          toastr.warning('Informe projeto, conta transitória, rubrica e subrubrica.');
          return;
        }

        if (this.tarifaProprioIniciada && !this.tarifaProprioCompleta) {
          this.secao = 'tarifas';
          toastr.warning('Informe rubrica, subrubrica e conta da tarifa lançada no próprio projeto.');
          return;
        }

        if (this.tarifaCentralIniciada && !this.tarifaCentralCompleta) {
          this.secao = 'tarifas';
          toastr.warning('Informe projeto, rubrica, subrubrica e conta da tarifa do projeto centralizador.');
          return;
        }

        const payload = Object.assign({}, this.configuracao);
        payload.dataCorteBanco = this.dataCorte ? moment(this.dataCorte).format('YYYY-MM-DD') : '';

        if (this.mesmaRubrica) {
          payload.idRubricaDebito = payload.idRubrica;
          payload.idSubRubricaDebito = payload.idSubRubrica;
        }

        const salvarIA = this.conteudoIA !== this.conteudoIAOriginal;
        const salvarTesouraria = this.tesourariaAlterada;

        this.salvando = true;
        conciliacaoProjetoServico.salvarConfiguracaoCredito(payload)
          .then(() => (this.textosAlterados ? conciliacaoProjetoServico.salvarTextosPadrao(this.textosParaEnvio()) : null))
          .then(() => {
            this.textosOriginal = JSON.stringify(this.textosParaEnvio());
            return salvarTesouraria ? conciliacaoProjetoServico.salvarConfiguracaoTesouraria(this.payloadTesouraria()) : null;
          })
          .then(() => {
            if (salvarTesouraria) this.tesourariaOriginal = JSON.stringify(this.payloadTesouraria());

            if (!salvarIA) {
              this.salvando = false;
              toastr.success('Configurações salvas.');
              this.$emit('salvo');
              return;
            }

            return conciliacaoProjetoServico.salvarGlossarioIA({ numeroBanco: this.bancoIA, conteudo: this.conteudoIA })
              .then(() => {
                this.salvando = false;
                this.conteudoIAOriginal = this.conteudoIA;
                toastr.success('Configurações e regras da IA salvas.');
                this.$emit('salvo');
              });
          })
          .catch(res => {
            this.salvando = false;
            toastr.error(res && res.body && res.body.message ? res.body.message : 'Não foi possível salvar as configurações.');
          });
      },
    },
  }
</script>

<template>
  <div class="conc-ov">
    <div class="conc-modal cfg-modal">

      <div class="cfg-head">
        <h4>Configurações da conciliação de banco</h4>
        <small class="cfg-sub">Valem para todo o módulo de conciliação de banco. Alterações só passam a valer depois de salvar.</small>
      </div>

      <div class="cfg-corpo-flex">

        <div class="cfg-nav">
          <div class="cfg-nav-tit">Seções</div>
          <button v-for="s in secoes" :key="s.chave" type="button" class="cfg-nav-item"
                  :class="{ ativa: secao === s.chave, 'cfg-nav-erro': secaoComFalta(s.chave) }" @click="irPara(s.chave)">
            <span class="cfg-nav-dot" :class="{ pend: !s.ok }"></span>
            <span class="cfg-nav-txt">
              <b>{{ s.titulo }}</b>
              <small>{{ s.resumo }}</small>
            </span>
          </button>
        </div>

        <div class="cfg-painel">
          <div v-if="carregando" class="cfg-carregando"><i class="fa fa-spinner fa-pulse fa-2x"></i></div>

          <template v-else>

            <template v-if="secao === 'corte'">
              <div class="cfg-sec-tit">Data de corte</div>
              <div class="cfg-sec-aj">
                Define o começo do histórico visível no módulo — grade, extrato, contas a receber, totais e dashboard.
                Entram os lançamentos da data em diante, inclusive o próprio dia.
              </div>

              <label class="cfg-rot">Considerar a partir de</label>
              <div class="cfg-corte-linha" :class="{ 'cfg-invalido': camposFaltando.dataCorte }">
                <date-picker id="dataCorteBanco" v-model="dataCorte" format="DD/MM/YYYY" lang="pt-br"
                             input-class="form-control" placeholder="dd/mm/aaaa" :editable="true" :shortcuts="false"
                             :clearable="true" :append-to-body="true" :popup-style="{ zIndex: 3200 }"></date-picker>
                <span v-if="camposFaltando.dataCorte" class="cfg-msg">{{ camposFaltando.dataCorte }}</span>
              </div>
            </template>

            <template v-if="secao === 'creditos'">
              <div class="cfg-sec-tit">Créditos a identificar</div>
              <div class="cfg-sec-aj">Destino dos lançamentos gerados quando o operador regulariza um crédito do extrato.</div>

              <div class="cfg-card">
                <div class="cfg-card-tit">Destino da regularização</div>
                <div class="cfg-card-aj">Crédito na conta do extrato, débito na conta transitória abaixo — os dois no projeto informado.</div>
                <div class="cfg-par">
                  <div class="cfg-campo" :class="{ 'cfg-invalido': camposFaltando.idProjeto }">
                    <label>Projeto</label>
                    <selecao-busca v-model="configuracao.idProjeto" :texto="configuracao.nomeProjeto" :buscar="buscarProjetos"
                                   placeholder="Buscar projeto..." @selecionado="aoEscolherProjeto"></selecao-busca>
                    <span v-if="camposFaltando.idProjeto" class="cfg-msg">{{ camposFaltando.idProjeto }}</span>
                  </div>
                  <div class="cfg-campo" :class="{ 'cfg-invalido': camposFaltando.idConta }">
                    <label>Conta transitória (TRA)</label>
                    <selecao-busca ref="conta" v-model="configuracao.idConta" :texto="configuracao.nomeConta" :buscar="buscarContas"
                                   :desabilitado="!configuracao.idProjeto" placeholder="Conta do projeto..." :auto-unico="true"
                                   @selecionado="o => configuracao.nomeConta = o ? o.nome : ''"></selecao-busca>
                    <span v-if="camposFaltando.idConta" class="cfg-msg">{{ camposFaltando.idConta }}</span>
                  </div>
                </div>
              </div>

              <div class="cfg-card">
                <div class="cfg-card-topo">
                  <div>
                    <div class="cfg-card-tit">Rubricas do lançamento</div>
                    <div class="cfg-card-aj">Só rubricas do projeto marcadas para a natureza, mais as sem marcação de receita ou despesa.</div>
                  </div>
                  <label class="cfg-switch-linha" @click.prevent="alternarMesmaRubrica">
                    <span class="cfg-switch" :class="{ on: mesmaRubrica }"><span class="cfg-knob"></span></span>
                    Mesma rubrica nos dois lados
                  </label>
                </div>

                <div class="cfg-par">
                  <div class="cfg-campo" :class="{ 'cfg-invalido': camposFaltando.idRubrica }">
                    <label>Rubrica<span v-if="!mesmaRubrica" class="cfg-lado"> — crédito</span></label>
                    <selecao-busca v-model="configuracao.idRubrica" :texto="configuracao.nomeRubrica" :buscar="buscarRubricas"
                                   :desabilitado="!configuracao.idProjeto" placeholder="Rubrica do projeto..."
                                   @selecionado="aoEscolherRubrica"></selecao-busca>
                    <span v-if="camposFaltando.idRubrica" class="cfg-msg">{{ camposFaltando.idRubrica }}</span>
                  </div>
                  <div class="cfg-campo" :class="{ 'cfg-invalido': camposFaltando.idSubRubrica }">
                    <label>Subrubrica<span v-if="!mesmaRubrica" class="cfg-lado"> — crédito</span></label>
                    <selecao-busca ref="subrubrica" v-model="configuracao.idSubRubrica" :texto="configuracao.nomeSubrubrica" :buscar="buscarSubrubricas"
                                   :desabilitado="!configuracao.idRubrica" placeholder="Subrubrica..." :auto-unico="true"
                                   @selecionado="o => configuracao.nomeSubrubrica = o ? o.nome : ''"></selecao-busca>
                    <span v-if="camposFaltando.idSubRubrica" class="cfg-msg">{{ camposFaltando.idSubRubrica }}</span>
                  </div>
                </div>

                <div v-if="!mesmaRubrica" class="cfg-card-debito">
                  <div class="cfg-card-sub">Débito — conta transitória</div>
                  <div class="cfg-par">
                    <div class="cfg-campo" :class="{ 'cfg-invalido': camposFaltando.idRubricaDebito }">
                      <label>Rubrica — débito</label>
                      <selecao-busca v-model="configuracao.idRubricaDebito" :texto="configuracao.nomeRubricaDebito" :buscar="buscarRubricasDebito"
                                     :desabilitado="!configuracao.idProjeto" placeholder="Rubrica do projeto..."
                                     @selecionado="aoEscolherRubricaDebito"></selecao-busca>
                      <span v-if="camposFaltando.idRubricaDebito" class="cfg-msg">{{ camposFaltando.idRubricaDebito }}</span>
                    </div>
                    <div class="cfg-campo" :class="{ 'cfg-invalido': camposFaltando.idSubRubricaDebito }">
                      <label>Subrubrica — débito</label>
                      <selecao-busca ref="subrubricaDebito" v-model="configuracao.idSubRubricaDebito" :texto="configuracao.nomeSubrubricaDebito" :buscar="buscarSubrubricasDebito"
                                     :desabilitado="!configuracao.idRubricaDebito" placeholder="Subrubrica..." :auto-unico="true"
                                     @selecionado="o => configuracao.nomeSubrubricaDebito = o ? o.nome : ''"></selecao-busca>
                      <span v-if="camposFaltando.idSubRubricaDebito" class="cfg-msg">{{ camposFaltando.idSubRubricaDebito }}</span>
                    </div>
                  </div>
                </div>

                <div class="cfg-par">
                  <div class="cfg-campo">
                    <label>Documento padrão dos lançamentos</label>
                    <input type="text" class="form-control" maxlength="60" v-model="configuracao.documento"
                           placeholder="TRA - ">
                  </div>
                  <div class="cfg-campo">
                    <label>Complemento padrão dos lançamentos</label>
                    <input type="text" class="form-control" maxlength="60" v-model="configuracao.complemento"
                           placeholder="TRA - ">
                  </div>
                </div>
                <small class="cfg-dica">
                  É o começo do texto do par TRA: o que o extrato trouxer (nome, CNPJ, histórico) é colado logo depois,
                  então deixe o espaço no final, ex.: "TRA - ". Sem nada no extrato, fica só este texto.
                  O documento é cortado em 20 caracteres, limite do Desktop.
                </small>

                <div v-if="!completo" class="cfg-alerta">
                  Enquanto projeto, conta transitória e rubrica/subrubrica não estiverem preenchidos,
                  a regularização de créditos fica indisponível na tela de conciliação.
                </div>
              </div>
            </template>

            <template v-if="secao === 'operacoes'">
              <div class="cfg-sec-tit">Transferências e aplicações</div>
              <div class="cfg-sec-aj">
                Valores que o botão <b>Regularizar</b> sugere ao criar o lançamento. Campos em branco nascem vazios e
                o operador preenche na hora.
              </div>

              <div class="cfg-card">
                <div class="cfg-card-tit">Transferência entre contas</div>
                <div class="cfg-card-aj">Mesmos campos que o Desktop pede na transferência e na solicitação.</div>
                <div class="cfg-par">
                  <div class="cfg-campo">
                    <label>Documento padrão</label>
                    <input type="text" class="form-control" maxlength="50"
                           placeholder="TRANSF.CTA.CENT" v-model="configuracao.documentoPadraoTransferencia">
                  </div>
                  <div class="cfg-campo">
                    <label>Complemento padrão</label>
                    <input type="text" class="form-control" maxlength="300"
                           placeholder="deixe vazio para preencher na hora"
                           v-model="configuracao.complementoPadraoTransferencia">
                  </div>
                </div>
                <div class="cfg-par">
                  <div class="cfg-campo">
                    <label>Categoria — débito</label>
                    <selecao-busca v-model="configuracao.idCategoriaFinanceiraDebito" :texto="configuracao.nomeCategoriaFinanceiraDebito"
                                   :buscar="buscarCategoriasFinanceiras" placeholder="opcional"
                                   @selecionado="o => configuracao.nomeCategoriaFinanceiraDebito = o ? o.nome : ''"></selecao-busca>
                  </div>
                  <div class="cfg-campo">
                    <label>Categoria — crédito</label>
                    <selecao-busca v-model="configuracao.idCategoriaFinanceiraCredito" :texto="configuracao.nomeCategoriaFinanceiraCredito"
                                   :buscar="buscarCategoriasFinanceiras" placeholder="opcional"
                                   @selecionado="o => configuracao.nomeCategoriaFinanceiraCredito = o ? o.nome : ''"></selecao-busca>
                  </div>
                </div>
                <small class="cfg-dica">
                  Vale para o lançamento direto e para a solicitação de transferência.
                  Nas transferências entre contas da FUSP a categoria usada é <b>TRANSFERENCIA ENTRE CONTAS FUSP</b>.
                </small>
              </div>

              <div class="cfg-card">
                <div class="cfg-card-tit">Lançamento automático de aplicação e resgate</div>
                <div class="cfg-card-aj">
                  No botão <b>Processar todas as contas</b>, as linhas do extrato reconhecidas como aplicação ou resgate
                  são lançadas sozinhas — sem passar pelo modal de regularização.
                </div>

                <label class="cfg-check">
                  <input type="checkbox" v-model="configuracao.automacaoAplicacaoResgate">
                  Lançar aplicação e resgate automaticamente
                </label>

                <div class="cfg-efeito">
                  Só vale para contas com <b>uma única aplicação ativa</b>, e essa aplicação precisa ter projeto em
                  vigência. Conta com duas ou mais aplicações continua manual. Abrir a conta na tela de conciliação
                  não lança nada: a automação roda apenas pelo botão da lista.
                </div>
              </div>

              <div class="cfg-card">
                <div class="cfg-card-tit">Identificação pelo histórico</div>
                <div class="cfg-card-aj">
                  Trechos procurados no histórico do extrato. Acentos e maiúsculas não importam. Aplicação e resgate
                  também são reconhecidos pela dica que vem na importação do extrato.
                </div>

                <div class="cfg-par">
                  <div class="cfg-campo">
                    <label>Transferência entre contas</label>
                    <div class="cfg-termos">
                      <span v-for="t in termosTransferencia" :key="t" class="cfg-termo">
                        {{ t }}
                        <a href="#" title="Remover" @click.prevent="removerTermo('transferencia', t)"><i class="fa fa-times"></i></a>
                      </span>
                      <input type="text" class="cfg-termo-novo" placeholder="+ adicionar termo"
                             v-model="novoTermo.transferencia"
                             @keydown.enter.prevent="adicionarTermo('transferencia')"
                             @blur="adicionarTermo('transferencia')">
                    </div>
                  </div>
                  <div class="cfg-campo">
                    <label>Aplicação e resgate</label>
                    <div class="cfg-termos">
                      <span v-for="t in termosAplicacao" :key="t" class="cfg-termo">
                        {{ t }}
                        <a href="#" title="Remover" @click.prevent="removerTermo('aplicacao', t)"><i class="fa fa-times"></i></a>
                      </span>
                      <input type="text" class="cfg-termo-novo" placeholder="+ adicionar termo"
                             v-model="novoTermo.aplicacao"
                             @keydown.enter.prevent="adicionarTermo('aplicacao')"
                             @blur="adicionarTermo('aplicacao')">
                    </div>
                  </div>
                </div>

                <div class="cfg-efeito">
                  Débito sem nenhuma dessas marcas vira <b>transferência</b>; crédito sem marca vira
                  <b>crédito a identificar</b>. O operador pode trocar a operação no próprio modal.
                </div>
              </div>
            </template>

            <template v-if="secao === 'textos'">
              <div class="cfg-sec-tit">Textos padrão</div>
              <div class="cfg-sec-aj">
                Textos prontos que o operador escolhe nos campos Documento, Complemento e Histórico da conciliação de banco.
                Eles aparecem na mesma listinha das sugestões tiradas do extrato, acima delas.
              </div>

              <div class="cfg-card">
                <div class="cfg-card-tit">Documento</div>
                <div class="cfg-card-aj">Até 50 caracteres por texto. A ordem daqui é a ordem que aparece na tela.</div>

                <div v-for="(t, i) in textos.documentos" :key="t.id" class="cfg-texto">
                  <input type="text" class="form-control" maxlength="50" v-model="t.texto"
                         ref="texto-documentos" placeholder="Texto do documento">
                  <button type="button" class="cfg-texto-btn" title="Subir" :disabled="i === 0"
                          @click="moverTexto('documentos', i, -1)"><i class="fa fa-arrow-up"></i></button>
                  <button type="button" class="cfg-texto-btn" title="Descer" :disabled="i === textos.documentos.length - 1"
                          @click="moverTexto('documentos', i, 1)"><i class="fa fa-arrow-down"></i></button>
                  <button type="button" class="cfg-texto-btn cfg-texto-rem" title="Remover"
                          @click="removerTexto('documentos', i)"><i class="fa fa-times"></i></button>
                </div>

                <div v-if="textos.documentos.length === 0" class="cfg-texto-vazio">Nenhum texto cadastrado.</div>

                <button type="button" class="cfg-texto-add" @click="adicionarTexto('documentos')">
                  <i class="fa fa-plus"></i> Adicionar texto
                </button>
              </div>

              <div class="cfg-card">
                <div class="cfg-card-tit">Complemento</div>
                <div class="cfg-card-aj">Até 300 caracteres por texto.</div>

                <div v-for="(t, i) in textos.complementos" :key="t.id" class="cfg-texto">
                  <input type="text" class="form-control" maxlength="300" v-model="t.texto"
                         ref="texto-complementos" placeholder="Texto do complemento">
                  <button type="button" class="cfg-texto-btn" title="Subir" :disabled="i === 0"
                          @click="moverTexto('complementos', i, -1)"><i class="fa fa-arrow-up"></i></button>
                  <button type="button" class="cfg-texto-btn" title="Descer" :disabled="i === textos.complementos.length - 1"
                          @click="moverTexto('complementos', i, 1)"><i class="fa fa-arrow-down"></i></button>
                  <button type="button" class="cfg-texto-btn cfg-texto-rem" title="Remover"
                          @click="removerTexto('complementos', i)"><i class="fa fa-times"></i></button>
                </div>

                <div v-if="textos.complementos.length === 0" class="cfg-texto-vazio">Nenhum texto cadastrado.</div>

                <button type="button" class="cfg-texto-add" @click="adicionarTexto('complementos')">
                  <i class="fa fa-plus"></i> Adicionar texto
                </button>
              </div>

              <div class="cfg-card">
                <div class="cfg-card-tit">Histórico</div>
                <div class="cfg-card-aj">Até 110 caracteres por texto. Aparece quando o operador escolhe <b>Outros</b> no lugar de pessoa física ou jurídica.</div>

                <div v-for="(t, i) in textos.historicos" :key="t.id" class="cfg-texto">
                  <input type="text" class="form-control" maxlength="110" v-model="t.texto"
                         ref="texto-historicos" placeholder="Texto do histórico">
                  <button type="button" class="cfg-texto-btn" title="Subir" :disabled="i === 0"
                          @click="moverTexto('historicos', i, -1)"><i class="fa fa-arrow-up"></i></button>
                  <button type="button" class="cfg-texto-btn" title="Descer" :disabled="i === textos.historicos.length - 1"
                          @click="moverTexto('historicos', i, 1)"><i class="fa fa-arrow-down"></i></button>
                  <button type="button" class="cfg-texto-btn cfg-texto-rem" title="Remover"
                          @click="removerTexto('historicos', i)"><i class="fa fa-times"></i></button>
                </div>

                <div v-if="textos.historicos.length === 0" class="cfg-texto-vazio">Nenhum texto cadastrado.</div>

                <button type="button" class="cfg-texto-add" @click="adicionarTexto('historicos')">
                  <i class="fa fa-plus"></i> Adicionar texto
                </button>

                <div class="cfg-efeito">
                  Texto em branco é descartado ao salvar, e texto repetido entra uma vez só.
                </div>
              </div>
            </template>

            <template v-if="secao === 'tarifas'">
              <div class="cfg-sec-tit">Tarifas TED/DOC</div>
              <div class="cfg-sec-aj">
                Destino do lançamento da tarifa de TED/DOC cobrada por borderô. O que decide qual dos dois casos vale é
                o cadastro do projeto — <b>permite lançamento de tarifa TED/DOC no projeto</b>. Aqui a fundação define,
                para cada caso, onde a tarifa entra.
              </div>

              <div class="cfg-card">
                <div class="cfg-card-tit">Projeto permite a tarifa</div>
                <div class="cfg-card-aj">
                  A tarifa fica no próprio projeto do borderô, então só rubrica, subrubrica e conta são definidas aqui.
                  Como o projeto muda a cada borderô, a lista traz rubricas e subrubricas do plano inteiro — o par
                  escolhido é procurado dentro do projeto na hora do lançamento.
                </div>
                <div class="cfg-par">
                  <div class="cfg-campo" :class="{ 'cfg-invalido': camposFaltando.idRubricaTarifaProprio }">
                    <label>Rubrica</label>
                    <selecao-busca v-model="configuracao.idRubricaTarifaProprio" :texto="configuracao.nomeRubricaTarifaProprio"
                                   :buscar="buscarRubricasTarifaProprio" placeholder="Rubrica da tarifa..."
                                   @selecionado="aoEscolherRubricaTarifaProprio"></selecao-busca>
                    <span v-if="camposFaltando.idRubricaTarifaProprio" class="cfg-msg">{{ camposFaltando.idRubricaTarifaProprio }}</span>
                  </div>
                  <div class="cfg-campo" :class="{ 'cfg-invalido': camposFaltando.idSubRubricaTarifaProprio }">
                    <label>Subrubrica</label>
                    <selecao-busca ref="subrubricaTarifaProprio" v-model="configuracao.idSubRubricaTarifaProprio"
                                   :texto="configuracao.nomeSubrubricaTarifaProprio" :buscar="buscarSubrubricasTarifaProprio"
                                   placeholder="Subrubrica..."
                                   @selecionado="o => configuracao.nomeSubrubricaTarifaProprio = o ? o.nome : ''"></selecao-busca>
                    <span v-if="camposFaltando.idSubRubricaTarifaProprio" class="cfg-msg">{{ camposFaltando.idSubRubricaTarifaProprio }}</span>
                  </div>
                </div>
                <div class="cfg-campo" :class="{ 'cfg-invalido': camposFaltando.idContaTarifaProprio }">
                  <label>Conta corrente</label>
                  <selecao-busca v-model="configuracao.idContaTarifaProprio" :texto="configuracao.nomeContaTarifaProprio"
                                 :buscar="buscarContasTarifaProprio" placeholder="Conta do débito da tarifa..."
                                 @selecionado="o => configuracao.nomeContaTarifaProprio = o ? o.nome : ''"></selecao-busca>
                  <span v-if="camposFaltando.idContaTarifaProprio" class="cfg-msg">{{ camposFaltando.idContaTarifaProprio }}</span>
                </div>
              </div>

              <div class="cfg-card">
                <div class="cfg-card-tit">Projeto não permite a tarifa</div>
                <div class="cfg-card-aj">
                  A tarifa vai para o projeto centralizador informado abaixo. Rubrica, subrubrica e conta só podem vir
                  desse projeto — trocá-lo limpa os três.
                </div>
                <div class="cfg-par">
                  <div class="cfg-campo" :class="{ 'cfg-invalido': camposFaltando.idProjetoTarifaCentral }">
                    <label>Projeto</label>
                    <selecao-busca v-model="configuracao.idProjetoTarifaCentral" :texto="configuracao.nomeProjetoTarifaCentral"
                                   :buscar="buscarProjetosTarifaCentral" placeholder="Buscar projeto..."
                                   @selecionado="aoEscolherProjetoTarifaCentral"></selecao-busca>
                    <span v-if="camposFaltando.idProjetoTarifaCentral" class="cfg-msg">{{ camposFaltando.idProjetoTarifaCentral }}</span>
                  </div>
                  <div class="cfg-campo" :class="{ 'cfg-invalido': camposFaltando.idContaTarifaCentral }">
                    <label>Conta corrente</label>
                    <selecao-busca ref="contaTarifaCentral" v-model="configuracao.idContaTarifaCentral"
                                   :texto="configuracao.nomeContaTarifaCentral" :buscar="buscarContasTarifaCentral"
                                   :desabilitado="!configuracao.idProjetoTarifaCentral" placeholder="Conta do projeto..." :auto-unico="true"
                                   @selecionado="o => configuracao.nomeContaTarifaCentral = o ? o.nome : ''"></selecao-busca>
                    <span v-if="camposFaltando.idContaTarifaCentral" class="cfg-msg">{{ camposFaltando.idContaTarifaCentral }}</span>
                  </div>
                </div>
                <div class="cfg-par">
                  <div class="cfg-campo" :class="{ 'cfg-invalido': camposFaltando.idRubricaTarifaCentral }">
                    <label>Rubrica</label>
                    <selecao-busca v-model="configuracao.idRubricaTarifaCentral" :texto="configuracao.nomeRubricaTarifaCentral"
                                   :buscar="buscarRubricasTarifaCentral" :desabilitado="!configuracao.idProjetoTarifaCentral"
                                   placeholder="Rubrica do projeto..." @selecionado="aoEscolherRubricaTarifaCentral"></selecao-busca>
                    <span v-if="camposFaltando.idRubricaTarifaCentral" class="cfg-msg">{{ camposFaltando.idRubricaTarifaCentral }}</span>
                  </div>
                  <div class="cfg-campo" :class="{ 'cfg-invalido': camposFaltando.idSubRubricaTarifaCentral }">
                    <label>Subrubrica</label>
                    <selecao-busca ref="subrubricaTarifaCentral" v-model="configuracao.idSubRubricaTarifaCentral"
                                   :texto="configuracao.nomeSubrubricaTarifaCentral" :buscar="buscarSubrubricasTarifaCentral"
                                   :desabilitado="!configuracao.idRubricaTarifaCentral" placeholder="Subrubrica..." :auto-unico="true"
                                   @selecionado="o => configuracao.nomeSubrubricaTarifaCentral = o ? o.nome : ''"></selecao-busca>
                    <span v-if="camposFaltando.idSubRubricaTarifaCentral" class="cfg-msg">{{ camposFaltando.idSubRubricaTarifaCentral }}</span>
                  </div>
                </div>
              </div>

              <div class="cfg-card">
                <div class="cfg-card-tit">Categoria financeira</div>
                <div class="cfg-card-aj">
                  Vale para os dois casos acima. Ao salvar, as tarifas de borderô já lançadas sem categoria recebem esta.
                </div>
                <div class="cfg-campo">
                  <label>Categoria da tarifa</label>
                  <selecao-busca v-model="configuracao.idCategoriaFinanceiraTarifa" :texto="configuracao.nomeCategoriaFinanceiraTarifa"
                                 :buscar="buscarCategoriasFinanceiras" placeholder="opcional"
                                 @selecionado="o => configuracao.nomeCategoriaFinanceiraTarifa = o ? o.nome : ''"></selecao-busca>
                </div>
              </div>

              <div v-if="!tarifasCompletas" class="cfg-alerta">
                Enquanto os dois casos não estiverem preenchidos, o lançamento de tarifa TED/DOC fica sem destino para
                parte dos projetos dos borderôs.
              </div>
            </template>

            <template v-if="secao === 'ia'">
              <div class="cfg-sec-tit">Regras da IA</div>
              <div class="cfg-sec-aj">
                Uma regra por linha. Abreviações valem na comparação dos históricos; frases soltas viram contexto e só
                geram sugestão — a IA nunca concilia sozinha.
              </div>

              <label class="cfg-rot">Vale para</label>
              <div class="cfg-ia-bancos">
                <button type="button" class="cfg-chip" :class="{ ativo: bancoIA === '' }" @click="trocarBancoIA('')">
                  Todos os bancos
                  <span v-if="globalIA.sinonimos + globalIA.orientacoes > 0" class="cfg-ia-qt">{{ globalIA.sinonimos + globalIA.orientacoes }}</span>
                </button>
                <button v-for="b in bancosIA" :key="b.numeroBanco" type="button" class="cfg-chip"
                        :class="{ ativo: bancoIA === b.numeroBanco }" @click="trocarBancoIA(b.numeroBanco)"
                        :title="b.nomeBanco">
                  {{ b.numeroBanco }}
                  <span v-if="b.sinonimos + b.orientacoes > 0" class="cfg-ia-qt">{{ b.sinonimos + b.orientacoes }}</span>
                </button>
              </div>

              <div class="cfg-ia-grid">
                <div>
                  <textarea class="form-control cfg-ia-texto" rows="11" v-model="conteudoIA" :disabled="carregandoIA"
                            placeholder="PAG BOL = PAGAMENTO BOLETO&#10;TED REC = TED RECEBIDA&#10;&#10;Créditos com histórico REPASSE FUSP costumam ser da conta 7269-9."></textarea>
                  <div class="cfg-ia-rodape">
                    <b>{{ sinonimosIA }}</b> abreviação<span v-if="sinonimosIA !== 1">ões</span>
                    <span class="cfg-pt">|</span>
                    <b>{{ orientacoesIA }}</b> orientação<span v-if="orientacoesIA !== 1">ões</span>
                    <span class="cfg-pt">|</span>
                    {{ escopoIA }}
                  </div>
                </div>
                <div class="cfg-ia-ajuda">
                  <div class="cfg-ia-ajuda-tit">Como escrever</div>
                  <div class="cfg-ia-exemplo-rot">Abreviação</div>
                  <code>PAG BOL = PAGAMENTO BOLETO</code>
                  <div class="cfg-ia-exemplo-rot">Orientação</div>
                  <code>Créditos com histórico REPASSE FUSP costumam ser da conta 7269-9.</code>
                </div>
              </div>
            </template>

            <template v-if="secao === 'tesouraria'">
              <div class="cfg-sec-tit">Posição de Tesouraria</div>
              <div class="cfg-sec-aj">
                Parâmetros da tela de Posição de Tesouraria: com que data ela abre, até onde olha os compromissos e o que
                conta como sobra para aplicar, aplicação parada ou compromisso atrasado.
              </div>

              <div v-if="carregandoTesouraria" class="cfg-carregando"><i class="fa fa-spinner fa-pulse fa-2x"></i></div>

              <template v-else>
                <div class="cfg-card">
                  <div class="cfg-card-tit">Posição</div>
                  <div class="cfg-card-aj">Data com que a tela abre e horizonte inicial dos compromissos. Na tela ainda dá para trocar pelos botões ou escolher uma data.</div>
                  <div class="cfg-par">
                    <div class="cfg-campo">
                      <label for="tesCfgReferencia">Data de referência</label>
                      <select id="tesCfgReferencia" class="form-control" v-model="tesouraria.diasUteisReferencia">
                        <option value="0">Hoje</option>
                        <option value="1">D-1 útil</option>
                        <option value="2">D-2 úteis</option>
                        <option value="3">D-3 úteis</option>
                        <option value="4">D-4 úteis</option>
                      </select>
                      <small class="cfg-dica">O saldo é o de todos os lançamentos até o fim desta data. Os compromissos começam no primeiro dia útil depois dela.</small>
                    </div>
                    <div class="cfg-campo">
                      <label for="tesCfgHorizonte">Compromissos até</label>
                      <select id="tesCfgHorizonte" class="form-control" v-model="tesouraria.horizonteCompromissos">
                        <option value="-1">Dia (data de referência)</option>
                        <option value="1">D+1</option>
                        <option value="2">D+2</option>
                        <option value="3">D+3</option>
                        <option value="5">Semana (D+5)</option>
                      </select>
                      <small class="cfg-dica">Contas a pagar e transferências com data programada até este dia útil depois da referência entram em "A pagar". "Dia" considera só a própria data de referência.</small>
                    </div>
                  </div>
                </div>

                <div class="cfg-card">
                  <div class="cfg-card-tit">Aplicação</div>
                  <div class="cfg-card-aj">Quando a conta entra em "Sobra para aplicar", "Saldo sem aplicação" e "Aplicação parada".</div>
                  <div class="cfg-par">
                    <div class="cfg-campo">
                      <label for="tesCfgValorMinimo">Valor mínimo para aplicar</label>
                      <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input id="tesCfgValorMinimo" type="text" class="form-control" v-model="tesouraria.valorMinimo" placeholder="10.000,00">
                      </div>
                      <small class="cfg-dica">Conta com livre para aplicar a partir deste valor entra em "Sobra para aplicar" ou "Saldo sem aplicação".</small>
                    </div>
                    <div class="cfg-campo">
                      <label for="tesCfgDiasParada">Aplicação parada após</label>
                      <div class="input-group">
                        <input id="tesCfgDiasParada" type="text" class="form-control" v-model="tesouraria.diasAplicacaoParada" placeholder="90">
                        <span class="input-group-addon">dias</span>
                      </div>
                      <small class="cfg-dica">Dias sem aplicação ou resgate para considerar a aplicação parada. Rendimento não conta como movimento: só aplicação, resgate e saldo inicial.</small>
                    </div>
                  </div>
                </div>

                <div class="cfg-card">
                  <div class="cfg-card-tit">Atrasados nos compromissos</div>
                  <div class="cfg-card-aj">Até quantos dias de atraso um compromisso ainda aparece na tela. Zero desliga.</div>
                  <div class="cfg-par">
                    <div class="cfg-campo">
                      <label for="tesCfgDiasAtraso">Contas a pagar até</label>
                      <div class="input-group">
                        <input id="tesCfgDiasAtraso" type="text" class="form-control" v-model="tesouraria.diasCompromissoAtrasado" placeholder="30">
                        <span class="input-group-addon">dias</span>
                      </div>
                      <small class="cfg-dica">Conta a pagar em aberto com previsão (ou, sem previsão, vencimento) vencida há até este número de dias entra como atrasada. Mais antigas ficam de fora.</small>
                    </div>
                    <div class="cfg-campo">
                      <label for="tesCfgDiasAtrasoTransf">Transferências até</label>
                      <div class="input-group">
                        <input id="tesCfgDiasAtrasoTransf" type="text" class="form-control" v-model="tesouraria.diasTransferenciaAtrasada" placeholder="30">
                        <span class="input-group-addon">dias</span>
                      </div>
                      <small class="cfg-dica">Solicitação de transferência liberada ou transferência ainda não paga, com data vencida há até este número de dias, entra na coluna Transferências.</small>
                    </div>
                  </div>
                </div>
              </template>
            </template>

          </template>
        </div>
      </div>

      <div class="cfg-foot">
        <div class="cfg-foot-l">
          <span v-if="temAlteracao" class="cfg-pend">
            {{ alteracoes }} alteração<span v-if="alteracoes !== 1">ões</span> não salva<span v-if="alteracoes !== 1">s</span>
          </span>
        </div>
        <div class="cfg-foot-r">
          <button type="button" class="btn btn-primary" :disabled="salvando || carregando" @click="salvar">
            <i class="fa" :class="salvando ? 'fa-spinner fa-pulse' : 'fa-check'"></i> Salvar configurações
          </button>
          <button type="button" class="btn cfg-sair" @click="fechar">
            <i class="fa fa-sign-out"></i> {{ temAlteracao ? 'Sair sem salvar' : 'Sair' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .conc-ov { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.52); z-index: 2000; display: flex; align-items: center; justify-content: center; padding: 22px; }
  .conc-modal { background: #fff; border-radius: 8px; box-shadow: 0 18px 48px rgba(16,24,40,.28), 0 2px 6px rgba(16,24,40,.16); }
  .cfg-modal { width: 1000px; max-width: 100%; height: 88vh; max-height: 720px; display: flex; flex-direction: column; overflow: hidden; }

  .cfg-head { flex: 0 0 auto; padding: 15px 22px; border-bottom: 1px solid #e6e9ed; }
  .cfg-head h4 { margin: 0; font-size: 16px; font-weight: 600; color: #1c2024; }
  .cfg-sub { display: block; font-size: 12.5px; color: #6b747e; margin-top: 3px; }

  .cfg-corpo-flex { flex: 1 1 auto; min-height: 0; display: grid; grid-template-columns: 232px 1fr; }
  .cfg-nav { border-right: 1px solid #e6e9ed; background: #fafbfc; padding: 14px 12px; overflow: auto; }
  .cfg-nav-tit { font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: .07em; color: #8a939c; padding: 0 8px; margin-bottom: 8px; }
  .cfg-nav-item { display: flex; align-items: flex-start; gap: 9px; width: 100%; text-align: left; background: none; border: 1px solid transparent; border-radius: 6px; padding: 9px 10px; margin-bottom: 3px; }
  .cfg-nav-item:hover { background: #f2f4f6; }
  .cfg-nav-item.ativa { background: #fff; border-color: #dfe3e8; box-shadow: 0 1px 2px rgba(16,24,40,.05); }
  .cfg-nav-dot { flex: none; width: 7px; height: 7px; border-radius: 50%; background: #18a689; margin-top: 5px; }
  .cfg-nav-dot.pend { background: #d68a00; }
  .cfg-nav-txt { min-width: 0; }
  .cfg-nav-txt b { display: block; font-size: 12.5px; font-weight: 600; color: #1c2024; }
  .cfg-nav-txt small { display: block; font-size: 11px; color: #8a939c; line-height: 1.35; margin-top: 2px; word-break: break-word; }
  .cfg-nav-item.ativa .cfg-nav-txt b { color: #0a6d4d; }

  .cfg-painel { overflow: auto; padding: 18px 22px 22px; }
  .cfg-carregando { text-align: center; color: #8a939c; padding: 60px 0; }
  .cfg-sec-tit { font-size: 15px; font-weight: 600; color: #1c2024; }
  .cfg-sec-aj { font-size: 12.5px; color: #6b747e; line-height: 1.5; margin: 4px 0 16px; }
  .cfg-rot { display: block; font-size: 12px; font-weight: 500; color: #3b444d; margin-bottom: 6px; }

  .cfg-card { border: 1px solid #e6e9ed; border-radius: 7px; padding: 14px 15px; margin-bottom: 14px; background: #fff; }
  .cfg-card:last-child { margin-bottom: 0; }
  .cfg-card-topo { display: flex; justify-content: space-between; align-items: flex-start; gap: 14px; margin-bottom: 12px; }
  .cfg-card-topo .cfg-card-aj { margin-bottom: 0; }
  .cfg-card-tit { font-size: 13px; font-weight: 600; color: #1c2024; }
  .cfg-check { display: flex; align-items: center; gap: 8px; margin: 10px 0 0; font-size: 13px; font-weight: 600; color: #2a3038; cursor: pointer; }
  .cfg-check input { margin: 0; width: 14px; height: 14px; }
  .cfg-card-aj { font-size: 11.5px; color: #8a939c; line-height: 1.45; margin: 3px 0 12px; }
  .cfg-card-sub { font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #7b848e; margin-bottom: 8px; }
  .cfg-card-debito { padding: 12px 13px; border: 1px solid #e6e9ed; border-radius: 6px; background: #fbfcfd; margin-bottom: 12px; }

  .cfg-par { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
  .cfg-campo { margin-bottom: 11px; }
  .cfg-par .cfg-campo { margin-bottom: 11px; }
  .cfg-campo:last-child { margin-bottom: 0; }
  .cfg-campo label { display: block; font-size: 12px; font-weight: 500; color: #3b444d; margin-bottom: 5px; }
  .cfg-campo-num { max-width: 120px; }
  .cfg-lado { font-weight: normal; color: #8a939c; }
  .cfg-dica { display: block; font-size: 11.5px; color: #8a939c; margin-top: 5px; line-height: 1.45; }

  .cfg-corte-linha { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
  .cfg-chip { height: 32px; padding: 0 13px; border-radius: 99px; border: 1px solid #c6ccd4; background: #fff; color: #5b6570; font-size: 12px; font-weight: 500; font-family: 'IBM Plex Mono', Consolas, monospace; }
  .cfg-chip:hover { background: #f4f6f8; }
  .cfg-chip.ativo { background: #e8f5ef; border-color: #0f8a5f; color: #0a6d4d; }

  .cfg-impacto { margin-top: 16px; background: #fffdf7; border: 1px solid #f0e2b8; border-left: 3px solid #d68a00; border-radius: 6px; padding: 12px 14px; }
  .cfg-impacto.invalido { background: #fdf1f1; border-color: #e4d7d7; border-left-color: #c0392b; }
  .cfg-impacto-tit { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .06em; color: #8a6d1f; }
  .cfg-impacto-txt { font-size: 12.5px; color: #5b6570; line-height: 1.5; margin-top: 5px; }
  .cfg-impacto-nums { display: flex; gap: 34px; margin-top: 14px; }
  .cfg-impacto-load { font-size: 12px; color: #8a939c; }
  .cfg-num b { display: block; font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 21px; font-weight: 600; color: #1c2024; line-height: 1.1; }
  .cfg-num span { font-size: 11.5px; color: #8a939c; }

  .cfg-switch-linha { display: inline-flex; align-items: center; gap: 9px; font-size: 12px; font-weight: 500; color: #3b444d; margin: 0; cursor: pointer; user-select: none; white-space: nowrap; }
  .cfg-switch { position: relative; width: 32px; height: 18px; border-radius: 99px; background: #c6ccd4; transition: background .15s; }
  .cfg-switch.on { background: #0f8a5f; }
  .cfg-knob { position: absolute; top: 2px; left: 2px; width: 14px; height: 14px; border-radius: 50%; background: #fff; box-shadow: 0 1px 2px rgba(16,24,40,.3); transition: left .15s; }
  .cfg-switch.on .cfg-knob { left: 16px; }

  .cfg-termos { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; min-height: 34px; padding: 5px 7px; border: 1px solid #c6ccd4; border-radius: 5px; background: #fff; }
  .cfg-termo { display: inline-flex; align-items: center; gap: 6px; padding: 3px 8px; background: #eef1f4; border-radius: 4px; font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 11.5px; color: #3b444d; }
  .cfg-termo a { color: #a4acb4; font-size: 10px; }
  .cfg-termo a:hover { color: #c0392b; }
  .cfg-termo-novo { flex: 1 1 90px; min-width: 90px; border: none; outline: none; font-size: 12px; color: #3b444d; background: transparent; }

  .cfg-texto { display: flex; align-items: center; gap: 6px; margin-bottom: 6px; }
  .cfg-texto .form-control { flex: 1; min-width: 0; }
  .cfg-texto-btn { flex: none; width: 30px; height: 30px; border: 1px solid #d3d8de; border-radius: 5px; background: #fff; color: #7b848e; font-size: 11px; }
  .cfg-texto-btn:hover:not(:disabled) { background: #f2f4f6; color: #3b444d; }
  .cfg-texto-btn:disabled { opacity: .4; }
  .cfg-texto-rem:hover { border-color: #e3b7b1; background: #fdf3f2; color: #c0392b; }
  .cfg-texto-vazio { font-size: 12px; color: #8a939c; padding: 4px 0 2px; }
  .cfg-texto-add { margin-top: 6px; border: 1px dashed #c6ccd4; border-radius: 5px; background: #fff; color: #0a6d4d; font-size: 12px; font-weight: 600; padding: 6px 12px; }
  .cfg-texto-add:hover { background: #eef9f4; border-color: #9fd4bf; }
  .cfg-efeito { font-size: 12px; color: #5b6570; margin-top: 12px; line-height: 1.5; background: #f7f9fa; border: 1px solid #eef1f4; border-radius: 6px; padding: 9px 11px; }
  .cfg-alerta { background: #fff8e6; border: 1px solid #f0dfae; border-radius: 5px; padding: 9px 11px; font-size: 12px; color: #8a6d1f; margin-top: 12px; }

  .cfg-ia-bancos { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 14px; }
  .cfg-ia-bancos .cfg-chip { height: 28px; padding: 0 11px; font-size: 11.5px; }
  .cfg-ia-qt { display: inline-block; margin-left: 5px; padding: 0 5px; border-radius: 99px; background: #e2e6ea; color: #5b6570; font-size: 10.5px; font-weight: 600; }
  .cfg-chip.ativo .cfg-ia-qt { background: #cbe9dc; color: #0a6d4d; }
  .cfg-ia-grid { display: grid; grid-template-columns: 1fr 250px; gap: 14px; align-items: start; }
  .cfg-ia-texto { font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 12.5px; line-height: 1.6; resize: vertical; }
  .cfg-ia-rodape { font-size: 11.5px; color: #6b747e; margin-top: 7px; }
  .cfg-ia-rodape b { color: #1c2024; }
  .cfg-pt { color: #c6ccd4; margin: 0 7px; }
  .cfg-ia-ajuda { background: #fafbfc; border: 1px solid #e6e9ed; border-radius: 6px; padding: 12px 13px; }
  .cfg-ia-ajuda-tit { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .06em; color: #8a939c; margin-bottom: 9px; }
  .cfg-ia-exemplo-rot { font-size: 11.5px; font-weight: 600; color: #5b6570; margin: 9px 0 4px; }
  .cfg-ia-ajuda code { display: block; background: #fff; border: 1px solid #e6e9ed; border-radius: 4px; padding: 6px 8px; font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 11px; color: #3b444d; white-space: pre-wrap; line-height: 1.45; }

  .cfg-foot { flex: 0 0 auto; display: flex; justify-content: space-between; align-items: center; gap: 12px; padding: 12px 22px; background: #fafbfc; border-top: 1px solid #e6e9ed; }
  .cfg-foot-l { font-size: 12px; color: #6b747e; }
  .cfg-pend { color: #8a6d1f; font-weight: 600; }
  .cfg-foot-r { display: flex; gap: 8px; }
  .cfg-sair { background: #fdf1f1; border: 1px solid #e4d7d7; color: #a13c3c; font-weight: 600; }
  .cfg-sair:hover { background: #fbe7e7; border-color: #d9c2c2; color: #a13c3c; }
</style>

<style>
  .cfg-modal .mx-datepicker-popup { z-index: 3200; }
  .cfg-modal .cfg-invalido .form-control,
  .cfg-modal .cfg-invalido .mx-datepicker input { border-color: #ED5565 !important; background: #fff8f8; box-shadow: 0 0 0 3px rgba(237,85,101,.2) !important; }
  .cfg-modal .cfg-invalido > label { color: #ED5565 !important; }
  .cfg-modal .cfg-nav-erro { box-shadow: inset 3px 0 0 #ED5565; }
  .cfg-modal .cfg-nav-erro .cfg-nav-txt b { color: #ED5565; }
  .cfg-modal .cfg-msg { display: block; margin-top: 4px; font-size: 12px; color: #ED5565; }
  .cfg-modal .mx-datepicker { position: relative; display: inline-block; vertical-align: middle; width: 150px !important; }
  .cfg-modal .mx-datepicker .mx-input-wrapper, .cfg-modal .mx-datepicker input { width: 150px; }
  .cfg-modal .mx-datepicker input { height: 32px; padding-right: 30px; border: 1px solid #c6ccd4; border-radius: 5px; box-shadow: none;
                         font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 13px; font-weight: 500; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/ConfiguracaoCreditoModal.vue